"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP6963EventNames = void 0;
var EIP6963EventNames;
(function (EIP6963EventNames) {
    EIP6963EventNames["Announce"] = "eip6963:announceProvider";
    EIP6963EventNames["Request"] = "eip6963:requestProvider";
})(EIP6963EventNames = exports.EIP6963EventNames || (exports.EIP6963EventNames = {}));
//# sourceMappingURL=eip6963.js.map